import { render } from "./RecentTweet.vue?vue&type=template&id=612f4bfd&scoped=true"
import script from "./RecentTweet.vue?vue&type=script&lang=js"
export * from "./RecentTweet.vue?vue&type=script&lang=js"

import "./RecentTweet.vue?vue&type=style&index=0&id=612f4bfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612f4bfd"]])

export default __exports__